var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-input", {
    style: { flexGrow: 0, flexShrink: 1, width: "600px" },
    attrs: { "icon-left": "search", icon: _vm.icon },
    on: {
      "icon-left-click": function ($event) {
        return _vm.onEnter()
      },
      "icon-click": function ($event) {
        return _vm.onClear()
      },
      focus: function ($event) {
        return _vm.onFocus()
      },
      blur: function ($event) {
        return _vm.onBlur()
      },
      keypress: function ($event) {
        if (
          !$event.type.indexOf("key") &&
          _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
        )
          return null
        return _vm.onEnter()
      },
    },
    model: {
      value: _vm.state.quickSearch,
      callback: function ($$v) {
        _vm.$set(_vm.state, "quickSearch", $$v)
      },
      expression: "state.quickSearch",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }